import { ReactComponent as GoogleMapRotateClockwhise } from 'assets/default/svg/google_maps_rotate_clockwise.svg'
import googlePegman from 'assets/default/png/google_pegman.png'
import { ReactComponent as PictoHeart } from 'assets/default/svg/picto_heart.svg'
import { Button } from 'react-bootstrap'
import s from './ResultatsCiblerBiens.module.scss'

const ResultatsCiblerBiens = (): JSX.Element => (
  <div className={s.tooltipResultatsCiblerBiens}>
    Les résultats qui s’affichent correspondent aux{' '}
    <b>
      biens répertoriés dans le cadastre et – pour ceux qui ont déjà fait
      l’objet d’une transaction – dans DVF
    </b>
    , dont les caractéristiques concordent avec vos critères de recherche.
    <br />
    <br />
    Voici les étapes à suivre pour géolocaliser votre bien :
    <ol>
      <li>Passez les biens en revue un par un en cliquant sur la flèche</li>
      <li>
        Vous voulez voir un bien de plus près ? Faites des rotations
        <span>
          <GoogleMapRotateClockwhise />
          <GoogleMapRotateClockwhise className={s.secondStreetViewRotate} />
        </span>{' '}
        et allez voir sa façade avec Google Steet View{' '}
        <img src={googlePegman} alt="Pegman" />
      </li>
      <li>
        Vous pensez l’avoir trouvé ? Mettez-le dans vos favoris{' '}
        <Button disabled className={s.buttonFavorite} variant="none">
          <PictoHeart />
        </Button>{' '}
        !
      </li>
    </ol>
    <b>
      A savoir : Pourquoi les fiches des biens affichent-elles différents
      niveaux de détail ?
    </b>
    <br />
    DVF contient plus de détails sur un bien que le cadastre. Or DVF ne
    répertorie que les biens qui ont fait l’objet d’une transaction depuis 2014.
    Par conséquent :
    <ul>
      <li>
        Si le bien que vous recherchez a déjà fait l’objet d’une vente par le
        passé, sa fiche sera plus détaillée. Vous pourrez même consulter
        l’historique de sa/ses vente(s) et son adresse exacte.
      </li>
      <li>
        Sinon, à vous de retrouver l’adresse exacte grâce à votre connaissance
        du quartier. Aidez-vous de Google Street View !
      </li>
    </ul>
  </div>
)

export default ResultatsCiblerBiens
